import React, { CSSProperties, ReactElement } from 'react';
import { StyledDropdown, DropdownContainer } from './Styles';

function Dropdown<U extends string | Record<string, unknown>>({
  options,
  selected = [],
  valueField,
  labelField,
  multi = false,
  placeholder = '',
  addPlaceholder,
  clearable,
  searchable = false,
  searchBy,
  onChange,
  contentRenderer,
  dropdownHandleRenderer,
  disabledLabel,
  itemTextColor,
  itemPaddingTop,
  itemPaddingBottom,
  style,
  containerStyle,
  disabled,
}: DropdownContainerProps<U>): ReactElement {
  return (
    <DropdownContainer style={containerStyle}>
      <StyledDropdown
        style={style}
        multi={multi}
        options={options}
        values={selected}
        // onChange typed as any to hide typing problem with library. See stackoverflow post
        // https://stackoverflow.com/questions/56505560/could-be-instantiated-with-a-different-subtype-of-constraint-object
        onChange={onChange as any} // eslint-disable-line @typescript-eslint/no-explicit-any
        valueField={valueField}
        labelField={labelField}
        clearable={clearable}
        placeholder={placeholder}
        addPlaceholder={addPlaceholder}
        searchable={searchable}
        searchBy={searchBy}
        contentRenderer={contentRenderer as any}
        disabledLabel={disabledLabel}
        disabled={disabled}
        dropdownHandleRenderer={dropdownHandleRenderer}
        itemTextColor={itemTextColor}
        itemPaddingTop={itemPaddingTop}
        itemPaddingBottom={itemPaddingBottom}
      />
    </DropdownContainer>
  );
}

export interface DropdownContainerProps<
T extends string | Record<string, unknown>
> {
  options: T[];
  selected?: T[];
  valueField: string;
  labelField: string;
  multi?: boolean;
  placeholder?: string;
  addPlaceholder?: string;
  // 是否显示一键清空
  clearable?: boolean;
  searchable?: boolean;
  // 搜索匹配字段
  searchBy?: string;
  disabledLabel?: string;
  onChange: (e: T[]) => void;
  // 自定义设置显示选中的项（可以设置图片、Html等）
  contentRenderer?: (props?: any) => JSX.Element;
  // 自定义设置显示下拉手柄图标（可以设置图片、Html等）
  dropdownHandleRenderer?: (props?: any) => JSX.Element;
  style?: CSSProperties;
  containerStyle?: CSSProperties;
  // 自定义选项文本颜色
  itemTextColor?: string;
  itemPaddingTop?: string;
  itemPaddingBottom?: string;
  disabled?: boolean;
}

export default Dropdown;
